import { render, staticRenderFns } from "./MenuAufstellungenComp.vue?vue&type=template&id=f77c7e94&scoped=true&"
import script from "./MenuAufstellungenComp.vue?vue&type=script&lang=ts&"
export * from "./MenuAufstellungenComp.vue?vue&type=script&lang=ts&"
import style0 from "./MenuAufstellungenComp.vue?vue&type=style&index=0&id=f77c7e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77c7e94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
